import React, { useRef, useEffect, useState } from 'react';
import axios from 'axios';
import SingleLossChart from '../components/SingleLossChart';
import CloudWatchChart from '../components/CloudWatchChart';
import html2canvas from 'html2canvas';
import '../dashboard.css';

function DashboardPage() {
  const gridRef = useRef(null);
  const [videoFiles, setVideoFiles] = useState([]);

  useEffect(() => {
    // ✅ 调用后端 API 获取视频文件名
    axios.get('/api/list-videos/')
      .then(res => setVideoFiles(res.data.videos))
      .catch(err => console.error('Failed to load videos:', err));
  }, []);

  const handleExportDashboard = () => {
    if (gridRef.current) {
      html2canvas(gridRef.current, { scale: 2 }).then((canvas) => {
        const link = document.createElement("a");
        link.download = "Training_Logs_dashboard.png";
        link.href = canvas.toDataURL("image/png");
        link.click();
      });
    }
  };

  const handleDownloadVideo = async (filename) => {
    try {
      const response = await fetch(`/api/download-video/${filename}`);
      if (!response.ok) {
        throw new Error(`Failed to download: ${response.status}`);
      }
      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = filename;
      link.click();
      window.URL.revokeObjectURL(url);
      console.log(`✅ Downloaded: ${filename}`);
    } catch (err) {
      console.error('❌ Download failed:', err);
      alert(`Download failed: ${err.message}`);
    }
  };

  return (
    <div>
      <div style={{ textAlign: 'center', marginTop: '20px' }}>
        <h1
          style={{
            fontSize: '28px',
            display: 'inline-block',
            marginRight: '16px',
            fontFamily: 'Inter, Helvetica, Arial, sans-serif',
            fontWeight: 600,
            color: '#222'
          }}
        >
          Training Logs Dashboard
        </h1>

        <button
          onClick={handleExportDashboard}
          style={{
            padding: '6px 12px',
            fontSize: '14px',
            border: '1px solid #ccc',
            borderRadius: '6px',
            cursor: 'pointer',
            background: 'white'
          }}
        >
          ⬇️ Export Dashboard
        </button>
      </div>

      {/* ✅ Loss 图表区域 */}
      <div className="dashboard-grid" ref={gridRef}>
        <div className="chart-card" style={{ height: '400px' }}>
          <SingleLossChart title="Total Loss" trainKey="t_loss" valKey="v_loss" />
        </div>
        <div className="chart-card" style={{ height: '400px' }}>
          <SingleLossChart title="Classification Loss" trainKey="t_cls_loss" valKey="v_cls_loss" />
        </div>
        <div className="chart-card" style={{ height: '400px' }}>
          <SingleLossChart title="Coordinate Loss" trainKey="t_coor_loss" valKey="v_coor_loss" />
        </div>
        <div className="chart-card" style={{ height: '400px' }}>
          <SingleLossChart title="Hurst Loss" trainKey="t_hurst_loss" valKey="v_hurst_loss" />
        </div>
        <div className="chart-card" style={{ height: '400px' }}>
          <SingleLossChart title="Diff Loss" trainKey="t_diff_loss" valKey="v_diff_loss" />
        </div>
        <div className="chart-card" style={{ height: '400px', justifyContent: 'center', color: '#999', textAlign: 'center' }}>
          None
        </div>
      </div>

      {/* ✅ 视频区块（动态渲染） */}
      <div style={{ marginTop: '40px' }}>
        <h2
          style={{
            fontSize: '28px',
            marginBottom: '16px',
            textAlign: 'center',
            fontFamily: 'Inter, Helvetica, Arial, sans-serif',
            fontWeight: 600,
            color: '#222'
          }}
        >
          Trajectory Prediction vs Ground Truth (Video)
        </h2>

        <div className="dashboard-grid" style={{ gridTemplateColumns: 'repeat(3, 1fr)' }}>
          {videoFiles.map((filename, i) => (
            <div key={i} className="chart-card" style={{ padding: 0 }}>
              <div style={{ fontSize: '14px', fontWeight: 600, marginBottom: '8px' }}>
                {filename}
              </div>
              <div style={{ position: 'relative', width: '100%', paddingTop: '100%' }}>
                <video
                  src={`/videos/${filename}`}
                  controls
                  muted
                  style={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    width: '100%',
                    height: '100%',
                    objectFit: 'cover',
                    borderRadius: '8px',
                    display: 'block'
                  }}
                />
              </div>
              <div style={{ textAlign: 'center', marginTop: '8px' }}>
                <button
                  onClick={() => handleDownloadVideo(filename)}
                  style={{
                    padding: '4px 10px',
                    fontSize: '13px',
                    border: '1px solid #ccc',
                    borderRadius: '6px',
                    cursor: 'pointer',
                    background: 'white'
                  }}
                >
                  ⬇️ Download {filename}
                </button>
              </div>
            </div>
          ))}

          {videoFiles.length === 0 && (
            <div className="chart-card" style={{ justifyContent: 'center', color: '#999', textAlign: 'center' }}>
              No videos found.
            </div>
          )}
        </div>
      </div>

      {/* ✅ CloudWatch Chart 区域 */}
      <CloudWatchChart />
    </div>
  );
}

export default DashboardPage;